import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import { isEmptyHtml } from '@/utils/helpers';

export default {
  components: {
    alertBox,
  },
  data() {
    return {
      depositWarning: '',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.DEPOSIT_WARNING)
      .then((data) => {
        if (!isEmptyHtml(data.renderedHTML)) {
          this.depositWarning = data.renderedHTML;
        }
      })
      .catch(() => {
        this.depositWarning = '';
      });
  },
};




// WEBPACK FOOTER //
// ./src/mixins/depositWarningMixin.js